/* [PATCH aplikacije-fe v1] Vstopna stran: izbira aplikacije (D2). Ruta "/" zunaj okvirja.
   Ena sama dovoljena aplikacija -> samodejno naprej (stranka z eno aplikacijo pride direktno noter),
   razen pri ?izbira=1 (namerna menjava iz glave okvirja, faza 3). */
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader } from 'lucide-react'; // [PATCH aplikacije-fe v1b] // [PATCH dostopi-pravice v1] ikone upravljanja so slike v public/aplikacije
import clsx from 'clsx';
import { APLIKACIJE, slikaAplikacije } from '../aplikacije'; // [PATCH aplikacije-fe v1b]
import { useMojeAplikacije } from '../hooks/useAplikacija';
import { VstopnaLupina } from '../components/VstopnaLupina';

export function IzbiraAplikacijePage() {
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const namerna = sp.get('izbira') === '1';
  const { podatki, loading, napaka, dovoljene, vidne, ponovno } = useMojeAplikacije(); // [PATCH pravice-app-podjetje v1] vidne

  useEffect(() => {
    if (!loading && !napaka && !namerna && dovoljene.length === 1) navigate('/app/' + dovoljene[0], { replace: true });
  }, [loading, napaka, namerna, dovoljene, navigate]);

  const pot = (id: string) => '/app/' + id + (namerna ? '?obdrzi=1' : '');

  return (
    <VstopnaLupina>{/* [PATCH aplikacije-fe v1b] brez naslova — samo aplikacije */}
      {loading ? (
        <div className="flex items-center justify-center h-48"><Loader className="w-8 h-8 text-blue-500 animate-spin" /></div>
      ) : napaka ? (
        <div className="rounded-2xl border border-red-200 bg-red-50 dark:bg-red-950/40 dark:border-red-900 p-6">
          <p className="text-red-700 dark:text-red-300">{napaka}</p>
          <button onClick={ponovno} className="mt-3 text-sm text-blue-600 hover:underline">Poskusi znova</button>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {APLIKACIJE.filter((a) => vidne.includes(a.id)).map((a) => { /* [PATCH pravice-app-podjetje v1] skrij aplikacije brez podjetja */
              const sme = dovoljene.includes(a.id);
              const na_voljo = a.aktivna && sme;
              return (
                <button key={a.id} onClick={() => { if (na_voljo) navigate(pot(a.id)); }} disabled={!na_voljo}
                  title={!a.aktivna ? 'Kmalu na voljo' : (!sme ? 'Aplikacija vam ni dodeljena' : a.naziv)}
                  className={clsx('relative rounded-2xl border p-6 transition group', /* [PATCH aplikacije-fe v1b] sredinsko */
                    na_voljo ? clsx(a.kartica, 'hover:shadow-lg hover:-translate-y-0.5 cursor-pointer')
                             : 'bg-gray-50 dark:bg-gray-900 border-gray-200 dark:border-gray-800 opacity-60 cursor-not-allowed grayscale')}>
                  <div className="flex flex-col items-center text-center">{/* [PATCH aplikacije-fe v1b] slikovna ikona namesto lucide cipa */}
                    <img src={slikaAplikacije(a.id)} alt="" draggable={false}
                      className={clsx('w-36 h-36 rounded-2xl object-contain transition', na_voljo ? 'group-hover:scale-105' : 'grayscale')} />
                    <p className="text-lg font-semibold mt-3">{a.naziv}</p>
                    <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">{a.podnaslov}</p>
                  </div>
                  {!a.aktivna && (
                    <span className="absolute top-4 right-4 text-[11px] font-medium px-2 py-0.5 rounded-full bg-gray-200 dark:bg-gray-800 text-gray-600 dark:text-gray-300">Kmalu na voljo</span>
                  )}
                  {a.aktivna && !sme && (
                    <span className="absolute top-4 right-4 text-[11px] font-medium px-2 py-0.5 rounded-full bg-gray-200 dark:bg-gray-800 text-gray-600 dark:text-gray-300">Ni dodeljena</span>
                  )}
                </button>
              );
            })}
          </div>
          {podatki && (podatki.superadmin || podatki.vloga === 'admin' || podatki.vloga === 'racunovodja' || podatki.upravlja_aplikacije) && ( /* [PATCH pravice-p3 v1] *//* [PATCH prodajni-tok v8] razdelek UPRAVLJANJE (ni aplikacija) */
            <div className="mt-10 pt-6 border-t border-gray-200 dark:border-gray-800">
              <p className="text-[11px] font-semibold tracking-wider text-gray-400 dark:text-gray-500 mb-3">UPRAVLJANJE</p>
              <div className="flex flex-wrap gap-3">
                <button onClick={() => navigate('/upravljanje')}
                  className="flex items-center gap-3 rounded-xl border bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-800 px-4 py-3 hover:border-blue-400 hover:shadow transition">
                  <img src="/aplikacije/dostopi.png" alt="" draggable={false} className="w-10 h-10 rounded-lg object-contain" />{/* [PATCH dostopi-pravice v1] */}
                  <span className="text-sm font-medium">Dostopi in pravice</span>
                </button>
                {podatki.superadmin && (
                  <button onClick={() => navigate('/superadmin')}
                    className="flex items-center gap-3 rounded-xl border bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-800 px-4 py-3 hover:border-blue-400 hover:shadow transition">
                    <img src="/aplikacije/superadmin.png" alt="" draggable={false} className="w-10 h-10 rounded-lg object-contain" />{/* [PATCH dostopi-pravice v1] */}
                    <span className="text-sm font-medium">Superadmin</span>
                  </button>
                )}
              </div>
            </div>
          )}
          {dovoljene.length === 0 && (
            <p className="mt-8 text-sm text-gray-500">Nimate dodeljene nobene aplikacije. Obrnite se na skrbnika{podatki?.vloga === 'stranka' ? ' vašega podjetja ali računovodski servis' : ''}.</p>
          )}
        </>
      )}
    </VstopnaLupina>
  );
}
